import { gql } from '@apollo/client';

export const racewayCodeFragments = {
  racewayCodeItem: gql`
    fragment RacewayCodeItem on RacewayCode {
      id
      projectId
      tag
      description
      racewayType
      hasSolidBottom
      physicalWidth
      physicalDepth
      designatedWidth
      designatedDepth
      maxFillAreaColumn1
      maxFillAreaColumn2
      weightPerUnit
      physicalArea
      racewaySize
      material
      bendRadius
      isBranchEnd
      costCode
      undergroundCostCode
      budgetQty
      unitPrice
      stockCodeType
      stockCode
      misc1
      misc2
      misc3
      misc4
      misc5
      misc6
      engineeringStatus
      revision
      ownerId
      preparedTime
      preparedBy
      checkedTime
      checkedBy
      approvedTime
      approvedBy
      isRestricted
      updatedTime
      updatedBy
      updatedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      approvedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      checkedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      preparedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      notes {
        id
        projectId
        parentId
        noteCommodityType
        noteType
        note
        updatedTime
        updatedBy
      }
    }
  `,
};
export const CREATE_RACEWAY_CODE = gql`
  ${racewayCodeFragments.racewayCodeItem}
  mutation CreateRacewayCode($createRacewayCodeInput: CreateRacewayCodeInput!) {
    createRacewayCode(createRacewayCodeInput: $createRacewayCodeInput) {
      racewayCode {
        ...RacewayCodeItem
      }
      errors
    }
  }
`;

export const DELETE_RACEWAY_CODE = gql`
  mutation DeleteRacewayCode($deleteRacewayCodeInput: DeleteRacewayCodeInput!) {
    deleteRacewayCode(deleteRacewayCodeInput: $deleteRacewayCodeInput) {
      id
      errors
    }
  }
`;

export const UPDATE_RACEWAY_CODE = gql`
  ${racewayCodeFragments.racewayCodeItem}
  mutation UpdateRacewayCode($updateRacewayCodeInput: UpdateRacewayCodeInput!) {
    updateRacewayCode(updateRacewayCodeInput: $updateRacewayCodeInput) {
      racewayCode {
        ...RacewayCodeItem
      }
      errors
    }
  }
`;

export const UPDATE_RACEWAY_CODES = gql`
  ${racewayCodeFragments.racewayCodeItem}
  mutation UpdateRacewayCodes($updateRacewayCodesInput: [UpdateRacewayCodeInput!]!) {
    updateRacewayCodes(updateRacewayCodesInput: $updateRacewayCodesInput) {
      racewayCodes {
        ...RacewayCodeItem
      }
      infos {
        tag
        messageKeys
      }
      errors {
        tag
        messageKeys
      }
    }
  }
`;

export const GET_RACEWAY_CODE_BY_ID = gql`
  ${racewayCodeFragments.racewayCodeItem}
  query RacewayCodeById($id: ID!) {
    racewayCodeById(id: $id) {
      ...RacewayCodeItem
    }
  }
`;

export const GET_RACEWAY_CODE_BY_IDS = gql`
  ${racewayCodeFragments.racewayCodeItem}
  query RacewayCodeByIds($ids: [ID!]!) {
    racewayCodeByIds(ids: $ids) {
      ...RacewayCodeItem
    }
  }
`;

export const SEARCH_RACEWAY_CODES = gql`
  query SearchRacewayCodes {
    searchRacewayCodes {
      items {
        id
        tag
        description
        racewaySize
        material
        racewayType
        updatedBy
        updatedTime
      }
    }
  }
`;

export const ISSUE_RACEWAY_CODES = gql`
  ${racewayCodeFragments.racewayCodeItem}
  mutation IssueRacewayCodes($issueRacewayCodesInput: [IssueRacewayCodeInput!]!) {
    issueRacewayCodes(issueRacewayCodesInput: $issueRacewayCodesInput) {
      racewayCodes {
        ...RacewayCodeItem
      }
      errors {
        tag
        messageKeys
      }
    }
  }
`;

export const CALCULATE_PHYSICAL_AREA = gql`
  query CalculatePhysicalArea($calculatePhysicalAreaInput: CalculatePhysicalAreaInput!) {
    calculatePhysicalArea(calculatePhysicalAreaInput: $calculatePhysicalAreaInput) {
      calculatedPhysicalArea
      errors
    }
  }
`;
